<template>
  <div class="text-primary">
    <template v-for="tramo in politicaCancelacion?.tramos" :key="tramo.id">
      <div class="col-12 row text-condicion">
        <span class="col text-primary">
          {{
            $t('home.form.policy.detail1Condiciones1', {
              fechaInicio: formatDate(tramo.fechaInicio),
              fechaFin: formatDate(tramo.fechaFin),
            })
          }}
        </span>
        <span v-if="tramo.porcentaje" class="text-secondary col-3 text-end"> {{ tramo.porcentaje }} %</span>
      </div>
    </template>
    <div v-if="fechaLimitePago" class="pt-4 text-condicion-2 text-primary">
      {{ $t('reserva.msjFechaLimite') }}

      {{ formatDate(fechaLimitePago) }}.
    </div>
  </div>
</template>

<script setup>
  import { formatDate } from '@/helpers/dateUtiles';
  // eslint-disable-next-line no-unused-vars
  const props = defineProps({
    politicaCancelacion: {
      type: Object,
      default: null,
      required: true,
    },
    fechaLimitePago: {
      type: String,
      default: null,
      required: false,
    },
    precioTotal: {
      type: Number,
      default: null,
      required: false,
    },
  });
</script>

<style lang="css" scoped>
  .text-condicion {
    font-size: 14px;
    font-weight: 400;
  }
  .text-condicion-2 {
    font-size: 13px;
    font-weight: 400;
  }
</style>
